/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_UnavailableInputs */

const en_us2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your photos arrived. The estimate is queued and shows up here in a few minutes. No need to take them again.`)
};

const pt_br2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suas fotos chegaram. A estimativa está na fila e aparece aqui em alguns minutos. Não precisa tirar de novo.`)
};

const es_419_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus fotos llegaron. La estimación está en cola y aparecerá aquí en unos minutos. No hace falta tomarlas de nuevo.`)
};

const pt_pt2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tuas fotografias chegaram. A estimativa está na fila e aparece aqui dentro de alguns minutos. Não precisas de as tirar outra vez.`)
};

const fr_fr2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes photos sont arrivées. L'estimation est en file d'attente et s'affichera ici dans quelques minutes. Pas besoin de les reprendre.`)
};

const de_de2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Fotos sind angekommen. Die Schätzung steht in der Warteschlange und erscheint hier in ein paar Minuten. Du musst sie nicht neu aufnehmen.`)
};

const it_it2_body_assessment_unavailable = /** @type {(inputs: Body_Assessment_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue foto sono arrivate. La stima è in coda e comparirà qui tra qualche minuto. Non serve scattarle di nuovo.`)
};

/**
* | output |
* | --- |
* | "Your photos arrived. The estimate is queued and shows up here in a few minutes. No need to take them again." |
*
* @param {Body_Assessment_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_unavailable = /** @type {((inputs?: Body_Assessment_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_unavailable(inputs)
	if (locale === "es-419") return es_419_body_assessment_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_unavailable(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_unavailable(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_unavailable(inputs)
	return en_us2_body_assessment_unavailable(inputs)
});
export { body_assessment_unavailable as "body_assessment.unavailable" }